<layout-block-list-outlet [list]="menu?.footerContent"></layout-block-list-outlet>
<div class="footer">
    <app-footer-menu></app-footer-menu>
    <app-footer-licenses>
        <app-footer-cards></app-footer-cards>
    </app-footer-licenses>
    <br>
    <app-footer-contact>
        <img [use]="footerLogo"
             [query]="{width:450 , height: 225}"
             [role]="'presentation'">
    </app-footer-contact>
    <app-footer-medias></app-footer-medias>
</div>
<app-footer-bedrock></app-footer-bedrock>
